export default {
  type: 'Photo',
  mask: '00',
  allow_unsecured_access: false,
  pdf_visibility: 0,
  web_visibility: 0,
  length: 0
};